(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["gym_log_book_client"] = factory();
	else
		root["gym_log_book_client"] = factory();
})(globalThis, () => {
return 